import React from 'react';

const OpinionsView = ({
	opinions,
	averageStars,
}) => (
	<div className="opinions">
		<div className="opinions__overall">
			{averageStars}
		</div>
		{opinions}
	</div>
);

export default OpinionsView;


// WEBPACK FOOTER //
// ./src/detail/OpinionsView.js